import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filedownload',
  templateUrl: './filedownload.component.html',
  styleUrls: ['./filedownload.component.css']
})
export class FiledownloadComponent implements OnInit {
  modalData: any={};
  modal: boolean;
  test : string = 'test';
  constructor(private router: Router) {
    this.router.navigate(["Apply/ApplyForm"]);
   }

  ngOnInit() {
  }

  open(item: number){
    this.modal = true;
    switch(item){
      case 1:
        this.modalData.title = '107年各用水標的用水範圍資料表';
        this.modalData.time = '2018-04-02';
        this.modalData.person = '用水範圍管理系統';
        this.modalData.contain = "用水範圍管理系統使用者您好： \n";
        this.modalData.contain += "配合水權登記審查作業要點自107年4月1日生效，各用水標的之用水範圍資料表已更新上架，請至「用水範圍管理系統」下載新版本表格使用。 \n";
        this.modalData.contain += "※若單位內office為2007前之版本，無法正常開啟.xlsx檔案時，請下載103年各用水標的用水範圍資料表(範例+空白)_office2003版本檔案。";
        this.modalData.contain += "或至微軟下載中心(http://www.microsoft.com/zh-tw/download/details.aspx?id=3)下載安裝「Microsoft Office Word、Excel 及 PowerPoint 檔案格式相容性套件」。\n";
        this.modalData.contain += "如有不了解之處，請洽04-24516669轉333，為您服務。";
        this.modalData.file =[
          {
            'title':'103新表件插入儲存格填寫教學.jpg',
            'url':'https://wr.wra.gov.tw/WRTInfoAPI/FileUpload/HomeDownload/103新表件插入儲存格填寫教學.jpg'
          },
          {
            'title':'4103年各用水標的用水範圍資料表(範例_空白)_office2007.rar',
            'url':'https://wr.wra.gov.tw/WRTInfoAPI/FileUpload/HomeDownload/4103年各用水標的用水範圍資料表(範例_空白)_office2007.rar'
          }
        ];
        break;
      case 2:
        this.modalData.title = '引水量記錄範例檔';
        this.modalData.time = '2018-04-02';
        this.modalData.person = '水權核辦系統';
        this.modalData.contain = "111";
        this.modalData.file =[
          {
            'title':'引水量記錄(範例)_1011005.xls',
            'url':'https://wr.wra.gov.tw/WRTData/File/Downloads/20121005175539055/引水量記錄(範例)_1011005.xls'
          }
        ];
        break;
    }

  }
}
